// features/spark/scripts/static-generate.ts 로 생성된 파일입니다.
// next.js 에서 이 파일을 복사해서 사용하면 됩니다.
import bannerdesktop960 from '@flipster/features/static/spark/reward/banner_desktop_960_1x.webp';
import bannerdesktop1920 from '@flipster/features/static/spark/reward/banner_desktop_960_2x.webp';
import banner from '@flipster/features/static/spark/reward/banner_mobile_360_1x.webp';
import bannermobile360 from '@flipster/features/static/spark/reward/banner_mobile_360_1x.webp';
import bannermobile720 from '@flipster/features/static/spark/reward/banner_mobile_360_2x.webp';
import bannermobile420 from '@flipster/features/static/spark/reward/banner_mobile_420_1x.webp';
import bannermobile840 from '@flipster/features/static/spark/reward/banner_mobile_420_2x.webp';
import bannermobile768 from '@flipster/features/static/spark/reward/banner_mobile_768_1x.webp';
import bannermobile1536 from '@flipster/features/static/spark/reward/banner_mobile_768_2x.webp';

export default {
  img: {
    src: banner.src,
    width: 360,
    height: 320,
    alt: 'Spark Rewards! Season 1',
  },
  sources: [
    {
      media: '(max-width: 767px)',
      srcSet: [
        `${bannermobile360.src} 360w`,
        `${bannermobile720.src} 720w`,
        `${bannermobile420.src} 420w`,
        `${bannermobile840.src} 840w`,
        `${bannermobile768.src} 768w`,
        `${bannermobile1536.src} 1536w`,
      ].join(', '),
      sizes: '100vw',
    },
    {
      srcSet: [`${bannerdesktop960.src} 960w`, `${bannerdesktop1920.src} 1920w`].join(', '),
      sizes: '960px',
    },
  ],
};
